<template>
  <div id="app">
    <van-nav-bar
      title="指派司机"
      fixed
      placeholder
      left-arrow
      @click-left="onClickLeft"
    />

    <div v-if="!loDingShow">
      <!-- 主题内容 -->
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="false"
          offset="10"
          @load="onLoad"
        >
          <div>
            <div class="sercer">
              <div @click="cityClick">
                {{ dq }}<van-icon name="arrow-down" />
              </div>
              <div>
                <input placeholder="输入司机姓名进行搜索" v-model="textIput" />
                <div><img :src="imgs" alt="" @click="removeTextIput" /></div>
              </div>
              <div @click="inputSL">搜索</div>
            </div>

            <van-radio-group
              v-model="radioGuest"
              direction="horizontal"
              checked-color="#FF9500"
              @change="change"
            >
              <div class="list" v-for="(c, i) in list" :key="i">
                <div>
                  <div>
                    <div>{{ c.realName }}</div>
                    <div>{{ c.carNumber }}</div>
                    <div>
                      <img
                        src="../../assets/icon/dh.png"
                        alt=""
                        @click="phone(c.phone)"
                      />
                    </div>
                  </div>

                  <div>
                    <div
                      v-if="c.driverStatus == 'CAR_STATUS-FREE'"
                      style="
                        color: #ff9500;
                        background: rgba(255, 149, 0, 0.1);
                        border: 1px solid #ff9500;
                      "
                    >
                      空闲
                    </div>

                    <div
                      v-if="c.driverStatus == 'CAR_STATUS-LIMIT_NUMBER'"
                      style="
                        color: #9ea0a5;
                        background: rgba(33, 37, 41, 0.1);
                        border: 1px solid #9ea0a5;
                      "
                    >
                      限号中
                    </div>

                    <div
                      v-if="c.driverStatus == 'CAR_STATUS-STOPPING'"
                      style="
                        color: #9ea0a5;
                        background: rgba(33, 37, 41, 0.1);
                        border: 1px solid #9ea0a5;
                      "
                    >
                      停车中
                    </div>

                    <div
                      v-if="c.driverStatus == 'CAR_STATUS-APPOINTMENT'"
                      style="
                        color: #9ea0a5;
                        background: rgba(33, 37, 41, 0.1);
                        border: 1px solid #9ea0a5;
                      "
                    >
                      待服务
                    </div>

                    <div
                      v-if="c.driverStatus == 'CAR_STATUS-IN_SERVICE'"
                      style="
                        color: #3278f3;
                        background: rgba(50, 120, 243, 0.1);
                        border: 1px solid #3278f3;
                      "
                    >
                      服务中
                    </div>

                    <div
                      v-if="c.driverStatus == 3"
                      style="
                        color: #e02020;
                        background: rgba(224, 32, 32, 0.1);
                        border: 1px solid #e02020;
                      "
                    >
                      禁用
                    </div>
                    <div
                      v-if="c.driverStatus == 'CAR_STATUS-STOPPING_SERVICE'"
                      style="
                        color: #e02020;
                        background: rgba(224, 32, 32, 0.1);
                        border: 1px solid #e02020;
                      "
                    >
                      暂停派单
                    </div>
                    <van-radio
                      style="margin-left: 20px"
                      :name="i"
                      v-if="c.driverStatus == 'CAR_STATUS-FREE'"
                    />

                    <!-- v-if="c.driverStatus == 'CAR_STATUS-FREE'" -->
                  </div>
                </div>
              </div>
            </van-radio-group>
          </div>
        </van-list>
      </van-pull-refresh>

      <div style="height: 60px"></div>
      <!-- 确定框 -->
      <div class="fixed-footers">
        <div class="fixed-footer">
          <div @click="adduserNAME">确认</div>
        </div>
      </div>
    </div>

    <div class="loDingClass" @touchmove.prevent="" v-if="loDingShow">
      <van-loading size="24px" vertical text-color="#ff9500" color="#ff9500"
        >加载中...</van-loading
      >
    </div>

    <van-action-sheet
      v-model="actionSheetShow"
      title="城市中文名"
      :round="false"
    >
      <div class="contents">
        <div
          v-for="(c, i) in cityList"
          :key="i"
          class="cityList"
          @click="cellClick(c)"
        >
          {{ c.cityName }}
        </div>
      </div>
    </van-action-sheet>


  </div>
</template>

<script>
import {
  NavBar,
  Icon,
  Radio,
  RadioGroup,
  Dialog,
  Toast,
  PullRefresh,
  List,
  Loading,
  ActionSheet,
} from "vant";
export default {
  data() {
    return {
      list: [],
      imgs: require("@/assets/icon/delete.png"),
      radioGuest: 0,
      textIput: "",
      lists: [],
      dq: "",
      sn: "",
      accountId: "",
      captainAccountId: "",
      refreshing: false,
      loading: false,
      finished: false,
      current: 1,
      idone: "",
      // 加载框
      loDingShow: false,
      cityCode: "",
      actionSheetShow: false,
      cityList: [],
    };
  },
  methods: {
    // 单选框选择 切换id  成功
    change(e) {
      var that = this;
      that.accountId = that.list[e].accountId;
      that.idone = that.list[e].accountId;
    },
    // 刷新页面   成功
    onRefresh() {
      var that = this;
      //  每次切换的时候 首先去除加载的样式
      that.finished = false;
      that.loading = false;
      // 默认加载
      that.loDingShow = true;
      // 设置为第一页
      that.current = 1;
      // 去除三个页面数据
      that.list = [];

      setTimeout(function () {
        that.get();
      }, 200);
    },
    // 下拉加载页面  暂且没问题
    onLoad() {
      this.current++;
      this.get();
    },
    //呼叫电话  安卓方法
    phone(p) {
      window.open("app:/#/call_driver?" + p + "&driver");
    },
    // 确定按钮 是否去指派司机
    adduserNAME() {
      // this.lists 选中后里面的数据
      // console.log(  this.captainId,"2222")
      Dialog.confirm({
        title: "指派",
        message: "是否确定指派该司机！",
      })
        .then(() => {
          let that = this;
          this.$axios
            .post(
              "/vedm/captainApp/confirmCaptain4Order",
              {
                // 车队长id   接收过来使用    成功
                captainId: that.captainAccountId,
                // 指派的司机id   成功
                driverAccountId: that.accountId || that.idone,
                // 订单号 本地 成功
                sn: localStorage.getItem("sn"),
              },
              {
                headers: {
                  Authorization: localStorage.getItem("token"),
                },
              }
            )
            .then((res) => {
              Dialog.alert({
                title: "提示",
                message: res.data.msg,
              }).then(() => {
                this.$router.back();
              });
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 回到上一页  成功
    onClickLeft() {
      this.$router.push({
        path: `homeManager`,
      });
    },
    // 输入框删除 成功
    removeTextIput() {
      var that = this;
      if (this.textIput.length >= 1) {
        // 去除输入的内容
        that.textIput = "";
        //  每次切换的时候 首先去除加载的样式
        that.finished = false;
        that.loading = false;
        // 默认加载
        that.loDingShow = true;
        // 设置为第一页
        that.current = 1;
        // 去除三个页面数据
        that.list = [];

        setTimeout(function () {
          that.get();
        }, 200);
      }
    },
    // 输入框点击搜索  成功
    inputSL() {
      var that = this;
      // carNumber
      if (this.textIput.length >= 1) {
        //  每次切换的时候 首先去除加载的样式
        that.finished = false;
        that.loading = false;
        // 默认加载
        that.loDingShow = true;
        // 设置为第一页
        that.current = 1;
        // 去除三个页面数据
        that.list = [];

        setTimeout(function () {
          that.get();
        }, 200);
      }
    },
    // 选择城市   等下修改
    cityClick() {
      this.getCity();
      this.actionSheetShow = true;
      // this.$router.push({
      //   path: `citys`,
      // });
    },
    // 指派司机列表
    get() {
      this.$axios({
        url: `/vedm/captainApp/getCaptainDriverPage4Order/${localStorage.getItem(
          "accountUid"
        )}/${localStorage.getItem("sn")}/${this.cityCode}?size=20&current=${
          this.current
        }&realName=${this.textIput}`,
        method: "get",
        // &realName=${
        //   this.textIput
        // }
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (res.data.code == 0) {
            // 加载成功
            this.loDingShow = false;
            // 默认司机id0个选中
            // console.log(,"222222")
            if (res.data.data) {
              console.log(res.data.data);
              // 数据合并
              var listd = [...this.list, ...res.data.data];
              this.list = listd;
              this.loading = false;
              // 第一个司机id选中
              this.idone = this.list[0].accountId;
              this.accountId = this.list[0].accountId;
              // 第一个司机id选中
              //  如果数据没有了，数据为空
              if (res.data.data.length == 0) {
                this.loading = true;
                this.finished = true;
              }
            } else {
              this.loading = true;
              this.finished = true;
            }

            this.refreshing = false;
          }

          // if (res.data.code == 0) {
          //   // this.refreshing = false;
          //   // this.list = res.data.data;
          //   // this.lists = res.data.data;
          //   // this.accountId = res.data.data[0].accountId;

          // }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取城市列表
    getCity() {
      this.$axios({
        url: `/vedm/captainApp/captainCityList/${localStorage.getItem(
          "accountUid"
        )}`,
        method: "get",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          // 关闭加载
          this.cityList = res.data.data;
        }
      });
    },
    // 选择城市后，重新设置数据
    cellClick(e) {
      var that = this;
      // cityCode: "130200"
      // cityName: "唐山市"
      this.dq=e.cityName
      this.cityCode = e.cityCode;
      //  每次切换的时候 首先去除加载的样式
      that.finished = false;
      that.loading = false;
      // 默认加载
      that.loDingShow = true;
      // 设置为第一页
      that.current = 1;
      // 去除三个页面数据
      that.list = [];
      setTimeout(function () {
        that.get();
        that.actionSheetShow = false;
      }, 200);

      console.log(e);
    },
  },
  mounted() {
    if (this.$route.query.captainAccountId) {
      console.log("获取车队长信息成功");
      this.captainAccountId = this.$route.query.captainAccountId;
    } else {
      Dialog.alert({
        title: "提示",
        message: "未获取到车队长信息,请重新进入该页面",
      }).then(() => {
        this.$router.back();
      });
    }

    if (this.$route.query.sn) {
      console.log("获取订单号成功");
      localStorage.setItem("sn", this.$route.query.sn);
    } else {
      Dialog.alert({
        title: "提示",
        message: "未获取到订单号,请重新进入该页面",
      }).then(() => {
        this.$router.back();
      });
    }

    if (localStorage.getItem("cityNumVehicles")) {
      console.log(1);
    }
    if (this.$route.query.cityName) {
      // 默认城市
      console.log("默认城市获取成功");
      this.dq = this.$route.query.cityName;
    } else {
      this.dq = "请选择城市";
    }

    if (this.$route.query.cityCode) {
      console.log("城市获取成功");
      this.cityCode = this.$route.query.cityCode;
    } else {
      this.dq = "请选择城市";
      Dialog.alert({
        title: "提示",
        message: "未获取到订单的城市,请自行选择城市",
      }).then(() => {});
    }
    this.get();
  },
  components: {
    "van-nav-bar": NavBar,
    "van-radio-group": RadioGroup,
    "van-radio": Radio,
    "van-icon": Icon,
    [Dialog.Component.name]: Dialog.Component,
    "van-pull-refresh": PullRefresh,
    "van-list": List,
    "van-loading": Loading,
    "van-action-sheet": ActionSheet,
  },
};
</script>

<style lang='less' scoped>
.cityList {
  width: 100%;
  height: 44px;
  background: #ffffff;
  padding: 0 0 0 15px;
  color: black;
  font-size: 12px;
  display: flex;
  align-items: center;
  caret-color: rgba(0, 0, 0, 0);
}
/deep/.van-action-sheet {
  height: 100% !important;
  max-height: 100% !important;
}
.contents {
  padding: 16px 16px 160px;
}
.loDingClass {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}
input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #c4c6cd;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #c4c6cd;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #c4c6cd;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #c4c6cd;
}
.fixed-footers {
  width: 100%;
  height: 60px;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
}

.fixed-footer {
  caret-color: rgba(0, 0, 0, 0);
  background-color: rgba(0, 0, 0, 0);
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;

  > div {
    width: 325px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #212529;
    border-radius: 6px;
    color: white;
  }
}
#app {
  font-size: 14px;
  color: #626870;
}
.sercer {
  width: 100%;
  display: flex;
  height: 30px;
  margin-top: 20px;
  > div:nth-child(1) {
    width: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: 1px solid #e8e9eb;
    caret-color: rgba(0, 0, 0, 0);
  }
  > div:nth-child(2) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 240px;
    padding: 0 16px;
  }
  > div:nth-child(3) {
    width: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid #e8e9eb;
    caret-color: rgba(0, 0, 0, 0);
  }
  input {
    width: 100%;
    caret-color: rgb(0, 0, 0);
  }
}
.list {
  width: 100%;
  caret-color: rgba(0, 0, 0, 0);
  img {
    width: 17px;
    height: 17px;
  }

  > div:nth-child(1) {
    margin: 30px 20px 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div:nth-child(1) {
      width: 173px;
      font-size: 14px;
      font-weight: 400;
      color: #212529;
      display: flex;
      justify-content: space-between;
      align-items: center;
      > div:nth-child(1) {
        font-weight: 500;
        font-size: 15px;
        color: #212529;
      }
    }
    > div:nth-child(2) {
      width: 112.5px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}

.class {
  margin-left: 18px;
  width: 35px;
  height: 16px;
  border-radius: 2px;
  font-size: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.class2 {
  margin-left: 18px;
  width: 45px;
  height: 16px;
  border-radius: 2px;
  font-size: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.color1 {
  background: rgba(255, 149, 0, 0.1);
  border-radius: 2px;
  border: 1px solid #ff9500;
  color: #ff9500;
}

.color2 {
  background: rgba(33, 37, 41, 0.1);
  border-radius: 2px;
  border: 1px solid #9ea0a5;
  color: #9ea0a5;
}

.color3 {
  background: rgba(50, 120, 243, 0.1);
  border-radius: 2px;
  border: 1px solid #3278f3;
  color: #3278f3;
}
</style>
